import httpClient from '@/http-client'

export const result = (Options = {}) => {
  return httpClient
    .get('/api/view/game-results', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const winner = (Options = {}) => {
  return httpClient
    .get('/api/view/game-betting-winners', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { result, winner }
